import { EDPData } from "@/models/loanApp/edpData";
import { getCompositeKey } from "@/services/format/key";
import envSettings from "@/services/system/envSettings";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { delay, http, HttpResponse } from "msw";
import { SetupServer } from "msw/node";
import { getPropertiesFullSet } from "../sets/loanAppSet";
import { infrastructureHandlers } from "./infrastructureHandlers";

const propertiesAdapter = createEntityAdapter({
  selectId: (item: EDPData) =>
    getCompositeKey({
      a: "properties",
      b: item.properties,
    }).toString(),
});
let propertiesState = propertiesAdapter.getInitialState();
propertiesState = propertiesAdapter.setOne(propertiesState, getPropertiesFullSet);

const url = `${envSettings.EDP_API_URL}/${envSettings.PROPERTY_PREF}`;

export const loanAppHandlers = [
  http.post(`${envSettings.FILTER_API_URL}/${envSettings.CREATE_LOAN_APP_PREF}`, async () => {
    await delay(150);
    return new HttpResponse(null, { status: 200 });
  }),

  http.get(url, async () => {
    await delay(150);
    return HttpResponse.json(Object.values(propertiesState.entities)[0], { status: 200 });
  }),
];

export const errorStatusLoanAppHandler = http.get(url, () => {
  return HttpResponse.json({ message: "Internal server error" }, { status: 500 });
});

export const faultyLoanAppHandler = http.get(url, () => {
  return HttpResponse.json({ weirdDataType: "Something went wrong" }, { status: 200 });
});

export const noDataLoanAppHandler = http.get(url, () => {
  return HttpResponse.json({ code: 6, reason: "No data" }, { status: 400 });
});

export const setupLoanAppHandler = (server: SetupServer) => {
  server.use(...loanAppHandlers, ...infrastructureHandlers);
};

export const setupErrorStatusLoanAppHandler = (server: SetupServer) => {
  server.use(errorStatusLoanAppHandler);
};

export const setupFaultyLoanAppHandler = (server: SetupServer) => {
  server.use(faultyLoanAppHandler);
};

export const setupNoDataLoanAppHandler = (server: SetupServer) => {
  server.use(noDataLoanAppHandler, ...infrastructureHandlers);
};
